/* torqv2 showcase · tryon-fixes r2 (per-finish try-on, a11y, download) */
(function() {
  'use strict';

  var progressBar = document.querySelector('.sc-progress-bar');
  var nav = document.querySelector('.sc-nav');
  var hamburger = document.querySelector('.sc-hamburger');
  var mobileMenu = document.querySelector('.sc-mobile-menu');
  var floatCart = document.querySelector('.sc-float-cart');
  var addToCartBtn = document.querySelector('.sc-float-cart-btn');
  var lastScroll = 0;

  function onScroll() {
    var y = window.scrollY;
    var docH = document.documentElement.scrollHeight - window.innerHeight;
    if (progressBar && docH > 0) {
      progressBar.style.transform = 'scaleX(' + (y / docH) + ')';
    }
    if (nav) {
      if (y > 100) nav.classList.add('scrolled');
      else nav.classList.remove('scrolled');
      if (y > 300 && y > lastScroll) nav.classList.add('hidden');
      else nav.classList.remove('hidden');
    }
    if (floatCart) {
      if (y > 400) floatCart.classList.add('visible');
      else floatCart.classList.remove('visible');
    }
    lastScroll = y;
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function() {
      hamburger.classList.toggle('open');
      mobileMenu.classList.toggle('open');
    });
    mobileMenu.querySelectorAll('a').forEach(function(a) {
      a.addEventListener('click', function() {
        hamburger.classList.remove('open');
        mobileMenu.classList.remove('open');
      });
    });
  }

  if (addToCartBtn) {
    var CART_ICON = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>';
    var CHECK_ICON = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
    var ALERT_ICON = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>';

    addToCartBtn.addEventListener('click', function() {
      var btn = this;
      var productId = btn.dataset.variantId;
      if (!productId) return;

      btn.classList.add('added');
      btn.setAttribute('aria-label', 'Added to cart');
      btn.innerHTML = CHECK_ICON;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(productId), quantity: 1 }] })
      })
      .then(function(res) { return res.json(); })
      .then(function() {
        setTimeout(function() {
          btn.classList.remove('added');
          btn.setAttribute('aria-label', 'Add to cart');
          btn.innerHTML = CART_ICON;
        }, 2000);
      })
      .catch(function() {
        btn.classList.remove('added');
        btn.setAttribute('aria-label', 'Error — try again');
        btn.innerHTML = ALERT_ICON;
        setTimeout(function() {
          btn.setAttribute('aria-label', 'Add to cart');
          btn.innerHTML = CART_ICON;
        }, 2000);
      });
    });
  }

  var reveals = document.querySelectorAll('.sc-reveal, .sc-reveal-left, .sc-reveal-scale');
  var measures = document.querySelectorAll('.sc-measure');

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '-8% 0px', threshold: 0.1 });

    reveals.forEach(function(el) { observer.observe(el); });
    measures.forEach(function(el) { observer.observe(el); });
  } else {
    reveals.forEach(function(el) { el.classList.add('visible'); });
    measures.forEach(function(el) { el.classList.add('visible'); });
  }

  var statEls = document.querySelectorAll('[data-count-to]');
  if (statEls.length > 0) {
    var countObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = el.dataset.countTo;
        var suffix = el.dataset.countSuffix || '';
        var num = parseFloat(target);
        if (isNaN(num)) { el.textContent = target + suffix; return; }
        var isDecimal = target.includes('.');
        var start = performance.now();
        var duration = 1500;
        function animate(now) {
          var elapsed = now - start;
          var progress = Math.min(elapsed / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 4);
          var current = num * eased;
          el.textContent = (isDecimal ? current.toFixed(1) : Math.round(current)) + suffix;
          if (progress < 1) requestAnimationFrame(animate);
        }
        requestAnimationFrame(animate);
        countObserver.unobserve(el);
      });
    }, { threshold: 0.3 });
    statEls.forEach(function(el) { countObserver.observe(el); });
  }

  var tryonBtn = document.querySelector('[data-tryon-trigger]');
  var tryonModal = document.querySelector('[data-tryon-modal]');
  if (tryonBtn && tryonModal) {
    var tryonInput = tryonModal.querySelector('[data-tryon-input]');
    var tryonDrop = tryonModal.querySelector('.sc-tryon-drop');
    var tryonDropImg = tryonModal.querySelector('.sc-tryon-drop-img');
    var tryonResult = tryonModal.querySelector('.sc-tryon-result');
    var tryonResultImg = tryonModal.querySelector('[data-tryon-result]');
    var tryonLoader = tryonModal.querySelector('[data-tryon-loader]');
    var tryonError = tryonModal.querySelector('[data-tryon-error]');
    var tryonSubmit = tryonModal.querySelector('[data-tryon-submit]');
    var tryonSubmitLabel = tryonModal.querySelector('[data-tryon-submit-label]');
    var tryonReset = tryonModal.querySelector('[data-tryon-reset]');
    var tryonDownload = tryonModal.querySelector('[data-tryon-download]');
    var tryonStepResult = tryonModal.querySelector('[data-tryon-step-result]');
    var tryonClosers = tryonModal.querySelectorAll('[data-tryon-close]');

    function normalizeUrl(u) {
      if (!u) return '';
      u = String(u).trim();
      if (!u) return '';
      if (u.indexOf('//') === 0) return window.location.protocol + u;
      if (/^https?:\/\//i.test(u)) return u;
      if (u.charAt(0) === '/') return window.location.origin + u;
      return 'https://' + u.replace(/^\/+/, '');
    }
    var endpoint = normalizeUrl(tryonBtn.dataset.tryonEndpoint);
    var watchUrl = normalizeUrl(tryonBtn.dataset.tryonImage);
    var variantName = tryonBtn.dataset.tryonVariant || '';
    var wristFile = null;
    var wristObjectUrl = null;
    var lastResultUrl = null;
    var lastVariant = variantName;
    var currentAbort = null;
    var requestSeq = 0;

    function showTryonBtn() { tryonBtn.classList.add('visible'); }
    function hideTryonBtn() { tryonBtn.classList.remove('visible'); }
    function tryonScroll() { if (window.scrollY > 300) showTryonBtn(); else hideTryonBtn(); }
    window.addEventListener('scroll', tryonScroll, { passive: true });
    tryonScroll();

    function setError(msg) {
      if (msg) { tryonError.textContent = msg; tryonError.hidden = false; }
      else { tryonError.textContent = ''; tryonError.hidden = true; }
    }

    function setSubmitState() {
      tryonSubmit.disabled = !wristFile;
      tryonSubmitLabel.textContent = lastResultUrl ? 'Regenerate' : 'Try It On';
    }

    function clearWrist() {
      if (wristObjectUrl) { URL.revokeObjectURL(wristObjectUrl); wristObjectUrl = null; }
      wristFile = null;
      tryonDropImg.hidden = true;
      tryonDropImg.removeAttribute('src');
      tryonDrop.classList.remove('has-image');
      tryonInput.value = '';
    }

    function clearResult() {
      lastResultUrl = null;
      tryonResultImg.hidden = true;
      tryonResultImg.removeAttribute('src');
      tryonResult.classList.remove('has-result');
      tryonDownload.hidden = true;
      tryonDownload.removeAttribute('href');
      if (tryonStepResult) tryonStepResult.textContent = '02 · Preview';
      tryonModal.classList.remove('has-result');
    }

    function fullReset() {
      if (currentAbort) { try { currentAbort.abort(); } catch (_) {} currentAbort = null; }
      requestSeq++;
      tryonLoader.hidden = true;
      tryonSubmit.classList.remove('is-loading');
      clearWrist();
      clearResult();
      setError('');
      setSubmitState();
    }

    var lastFocusedEl = null;

    function openModal() {
      lastFocusedEl = document.activeElement;
      // The preview placeholder must show the finish the shopper actually has
      // selected, not the section's static default image.
      var ph = tryonModal.querySelector('[data-tryon-placeholder]');
      if (ph) {
        var f = selectedFinish();
        var img = normalizeUrl(finishWatchImage(f)) || watchUrl;
        if (img) ph.src = img;
      }
      tryonModal.hidden = false;
      requestAnimationFrame(function() {
        tryonModal.classList.add('open');
        var closeBtn = tryonModal.querySelector('.sc-tryon-close');
        if (closeBtn) closeBtn.focus();
      });
      document.body.classList.add('sc-tryon-locked');
    }

    function closeModal() {
      tryonModal.classList.remove('open');
      document.body.classList.remove('sc-tryon-locked');
      setTimeout(function() {
        tryonModal.hidden = true;
        fullReset();
        if (lastFocusedEl && typeof lastFocusedEl.focus === 'function') lastFocusedEl.focus();
        lastFocusedEl = null;
      }, 280);
    }

    tryonBtn.addEventListener('click', openModal);
    Array.prototype.forEach.call(tryonClosers, function(el) { el.addEventListener('click', closeModal); });
    document.addEventListener('keydown', function(e) {
      if (!tryonModal.classList.contains('open')) return;
      if (e.key === 'Escape') { closeModal(); return; }
      if (e.key !== 'Tab') return;
      // Keep Tab focus inside the dialog while it is open.
      var focusables = tryonModal.querySelectorAll('button:not([disabled]), a[href], input:not([hidden]), select, textarea, [tabindex]:not([tabindex="-1"])');
      var list = Array.prototype.filter.call(focusables, function(el) { return el.offsetParent !== null; });
      if (!list.length) return;
      var first = list[0], last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (document.activeElement === last || !tryonModal.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
    });

    var ACCEPTED_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'];
    function acceptWristFile(file) {
      if (!file) return;
      if (ACCEPTED_TYPES.indexOf(file.type) === -1) {
        tryonInput.value = '';
        setError('Please use a JPEG, PNG, WebP, or GIF photo.');
        return;
      }
      if (file.size > 12 * 1024 * 1024) {
        tryonInput.value = '';
        setError('Image is too large (max 12 MB).');
        return;
      }
      setError('');
      clearResult();
      if (wristObjectUrl) URL.revokeObjectURL(wristObjectUrl);
      wristFile = file;
      wristObjectUrl = URL.createObjectURL(file);
      tryonDropImg.src = wristObjectUrl;
      tryonDropImg.hidden = false;
      tryonDrop.classList.add('has-image');
      setSubmitState();
    }

    tryonInput.addEventListener('change', function(e) {
      acceptWristFile(e.target.files && e.target.files[0]);
    });

    // Drag-and-drop onto the drop zone; swallow stray drops anywhere in the
    // open modal so a missed drop can't navigate the page to the file.
    tryonDrop.addEventListener('dragover', function(e) { e.preventDefault(); tryonDrop.classList.add('is-dragging'); });
    tryonDrop.addEventListener('dragleave', function() { tryonDrop.classList.remove('is-dragging'); });
    tryonDrop.addEventListener('drop', function(e) {
      e.preventDefault();
      tryonDrop.classList.remove('is-dragging');
      acceptWristFile(e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]);
    });
    document.addEventListener('dragover', function(e) { if (tryonModal.classList.contains('open')) e.preventDefault(); });
    document.addEventListener('drop', function(e) { if (tryonModal.classList.contains('open')) e.preventDefault(); });

    tryonReset.addEventListener('click', fullReset);

    tryonDownload.addEventListener('click', function(e) {
      // The result URL is cross-origin, so the anchor's download attribute is
      // ignored by browsers — always take the blob path instead of navigating.
      e.preventDefault();
      if (!lastResultUrl) return;
      var ua = navigator.userAgent || '';
      var isIOS = /iPad|iPhone|iPod/.test(ua) || (ua.indexOf('Mac') !== -1 && 'ontouchend' in document);
      var safeName = (lastVariant || 'watch').toLowerCase().replace(/\s+/g, '-');
      var filename = 'torq-tryon-' + safeName + '.jpg';
      fetch(lastResultUrl)
        .then(function(r) { return r.blob(); })
        .then(function(blob) {
          if (isIOS) {
            var file = new File([blob], filename, { type: blob.type || 'image/jpeg' });
            if (navigator.canShare && navigator.share && navigator.canShare({ files: [file] })) {
              return navigator.share({ files: [file], title: 'TorQ Try-On' }).catch(function(err) {
                if (err && err.name === 'AbortError') return;
                throw err;
              });
            }
          }
          var u = URL.createObjectURL(blob);
          var a = document.createElement('a');
          a.href = u;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          setTimeout(function() { URL.revokeObjectURL(u); }, 60000);
        })
        .catch(function() {
          window.open(lastResultUrl, '_blank', 'noopener');
        });
    });

    // The try-on must follow the finish the shopper actually selected — read the
    // configurator's current colour and resolve its hero image from the colormap,
    // falling back to the section's static image for direct/edge cases.
    function selectedFinish() {
      var el = document.querySelector('#sc-configure [data-sc-selected]');
      var name = el ? el.textContent.trim() : '';
      return (name && name.charAt(0) !== '—') ? name : '';
    }
    function finishWatchImage(name) {
      if (!name) return '';
      try {
        var mapEl = document.querySelector('[data-sc-colormap]');
        if (!mapEl) return '';
        var map = JSON.parse(mapEl.textContent);
        return (map[name] && map[name].hero) ? map[name].hero : '';
      } catch (_) { return ''; }
    }

    tryonResultImg.addEventListener('error', function() {
      if (!lastResultUrl) return;
      tryonResultImg.hidden = true;
      setError('Could not display the result image. Use Download to save it.');
    });

    tryonSubmit.addEventListener('click', function() {
      if (!wristFile) { setError('Upload a photo of your wrist first.'); return; }
      if (!endpoint) { setError('Try-on endpoint is not configured.'); return; }
      var finish = selectedFinish();
      var effWatchUrl = normalizeUrl(finishWatchImage(finish)) || watchUrl;
      var effVariant = finish || variantName;
      if (!effWatchUrl) { setError('No watch image is available for this product.'); return; }
      if (currentAbort) { try { currentAbort.abort(); } catch (_) {} }
      currentAbort = (typeof AbortController !== 'undefined') ? new AbortController() : null;
      var mySeq = ++requestSeq;
      setError('');
      tryonSubmit.disabled = true;
      tryonSubmit.classList.add('is-loading');
      tryonLoader.hidden = false;
      tryonResultImg.hidden = true;
      tryonResult.classList.remove('has-result');
      tryonModal.classList.add('has-result');

      var fetchOpts = { mode: 'cors' };
      if (currentAbort) fetchOpts.signal = currentAbort.signal;

      fetch(effWatchUrl, fetchOpts)
        .then(function(r) { if (!r.ok) throw new Error('Could not load watch image'); return r.blob(); })
        .then(function(watchBlob) {
          if (mySeq !== requestSeq) throw new DOMException('aborted', 'AbortError');
          var fd = new FormData();
          fd.append('wrist', wristFile, wristFile.name || 'wrist.jpg');
          var watchName = (effVariant || 'watch').toLowerCase().replace(/\s+/g, '-') + '.png';
          fd.append('watch', watchBlob, watchName);
          if (effVariant) fd.append('variantName', effVariant);
          var postOpts = { method: 'POST', body: fd };
          if (currentAbort) postOpts.signal = currentAbort.signal;
          return fetch(endpoint, postOpts);
        })
        .then(function(res) {
          // Non-JSON bodies (proxy 502 pages, wrong endpoint path) must surface
          // as a friendly message, not a JSON.parse error.
          return res.json().catch(function() {
            throw new Error('The try-on service returned an unexpected response (' + res.status + '). Please try again.');
          }).then(function(data) { return { ok: res.ok, status: res.status, data: data }; });
        })
        .then(function(out) {
          if (mySeq !== requestSeq) return;
          if (!out.ok) throw new Error((out.data && out.data.error) || 'Generation failed (' + out.status + ')');
          if (!out.data || !out.data.imageUrl) throw new Error('No image returned.');
          lastResultUrl = out.data.imageUrl;
          lastVariant = effVariant;
          tryonResultImg.src = lastResultUrl;
          tryonResultImg.hidden = false;
          tryonResult.classList.add('has-result');
          tryonDownload.href = lastResultUrl;
          tryonDownload.hidden = false;
          if (tryonStepResult) tryonStepResult.textContent = '02 · Result';
        })
        .catch(function(err) {
          if (mySeq !== requestSeq) return;
          if (err && err.name === 'AbortError') return;
          setError((err && err.message) || 'Generation failed.');
          // On mobile the result column replaces the upload column; roll back so
          // a failed first attempt doesn't strand the user with no upload UI.
          if (!lastResultUrl) tryonModal.classList.remove('has-result');
        })
        .finally(function() {
          if (mySeq !== requestSeq) return;
          tryonLoader.hidden = true;
          tryonSubmit.classList.remove('is-loading');
          setSubmitState();
        });
    });
  }

  var isMobile = window.innerWidth < 768;
  var particleContainer = document.querySelector('.sc-particles');
  if (particleContainer) {
    var count = isMobile ? 6 : 20;
    for (var i = 0; i < count; i++) {
      var p = document.createElement('div');
      p.className = 'sc-particle';
      var size = Math.random() * 2 + 1;
      p.style.cssText = 'left:' + (Math.random()*100) + '%;top:' + (Math.random()*100) + '%;width:' + size + 'px;height:' + size + 'px;animation-duration:' + (Math.random()*10+15) + 's;animation-delay:' + (Math.random()*5) + 's;';
      particleContainer.appendChild(p);
    }
  }
})();
